import { Carousel } from '@/core/tamagoshi/Carousel/Carousel';
import { Skeleton } from '@/core/tamagoshi/Skeleton/Skeleton';
import { Text } from '@/core/tamagoshi/Text/Text';

import { ProductToCompareSkeleton } from './components/ProductToCompare/ProductToCompareSkeleton';
import { compareWith } from './translations';

import styles from './productComparator.module.scss';

export const ProductComparatorSkeleton = () => (
  <div className={styles.root} data-testid={'product-comparator-skeleton'}>
    <Carousel
      title={
        <Text tag="span" type="h4" weight="bold" className={styles.title}>
          {compareWith}
        </Text>
      }
      sliderClassName={styles.container}
      controlsClassName={styles.carouselControls}
      dataTestId="productComparatorSkeleton"
    >
      {[1, 2, 3, 4, 5].map((index) => (
        <ProductToCompareSkeleton key={`product-to-compare-${index}`} />
      ))}
    </Carousel>
    <Skeleton className={styles.readMore} height={48} type="button" />
  </div>
);

ProductComparatorSkeleton.displayName = 'ProductComparatorSkeleton';
